// Store global partagé entre AccueilPage et ExplorePage
const store = {
  products: [],
  listeners: new Set(),

  add(newProducts) {
    const seen = new Set(this.products.map(p => p._col + p.id));
    const fresh = newProducts.filter(p => !seen.has(p._col + p.id));
    if (!fresh.length) return;
    this.products = [...this.products, ...fresh];
    this.listeners.forEach(fn => fn(this.products));
  },

  get() { return this.products; },

  subscribe(fn) {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  },
};

export default store;
